export const cleanCanonicalUrl = () => {
  const urlWithoutParams = window.location.href.split('?')[0].replace(/\/+$/, '');

  const pageParam = new URLSearchParams(window.location.search).get('page');

  return pageParam ? `${urlWithoutParams}?page=${pageParam}` : urlWithoutParams;
};